import React from "react";
import { Add, Edit, Delete, Clear, Refresh } from "@mui/icons-material";

const Button = ({ variant = "primary", icon, size = "md", children, className = "", ...props }) => {
  const variants = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    success: "bg-green-600 hover:bg-green-700 text-white",
    danger: "bg-red-600 hover:bg-red-700 text-white",
    secondary: "bg-gray-600 hover:bg-gray-700 text-white",
  };

  const sizes = {
    md: "px-6 py-2.5 text-[13px]",
    sm: "px-3 py-1.5 text-xs"
  };

  const icons = {
    add: <Add sx={{ fontSize: size === "sm" ? 14 : 18 }} />,
    update: <Edit sx={{ fontSize: size === "sm" ? 14 : 18 }} />,
    delete: <Delete sx={{ fontSize: size === "sm" ? 14 : 18 }} />,
    clear: <Clear sx={{ fontSize: size === "sm" ? 14 : 18 }} />,
    refresh: <Refresh sx={{ fontSize: size === "sm" ? 14 : 18 }} />,
  };

  return (
    <button
      {...props}
      className={`
        inline-flex items-center justify-center gap-2 rounded-md font-medium
        transition-colors duration-200 shadow-sm
        disabled:opacity-50 disabled:cursor-not-allowed
        ${sizes[size] || sizes.md} ${variants[variant]} ${className}
      `}
    >
      {icon && icons[icon]}
      {children}
    </button>
  );
};

export default Button;